import { twMerge } from "tailwind-merge";

interface AddEntityButtonProps {
  text: string | React.ReactNode;
  containerClassName?: string;
  iconContainerClassName?: string;
  iconClassName?: string;
  textClassName?: string;
  onClick: () => void;
}

export const AddEntityButton = ({
  text,
  containerClassName,
  iconContainerClassName,
  iconClassName,
  textClassName,
  onClick,
}: AddEntityButtonProps) => {
  return (
    <div
      className={twMerge(
        "flex items-center gap-1.5 px-3.5 py-2 bg-primary rounded-lg shadow-md hover:cursor-pointer",
        containerClassName
      )}
      onClick={onClick}
    >
      <div
        className={twMerge(
          "flex justify-center items-center w-4 h-4 border border-white rounded-full",
          iconContainerClassName
        )}
      >
        <i
          className={twMerge(
            "pi pi-plus text-[7px] text-white font-black",
            iconClassName
          )}
        />
      </div>
      <div className={twMerge("text-xs font-bold text-white", textClassName)}>
        {text}
      </div>
    </div>
  );
};
